import axiosInstance from 'api/axiosInstance'

export const sendContactMessage = async (contactData: {
    email: string
    name: string
    username?: string | null
    message: string
}) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/contact',
        data: contactData
    })
    return data
}